module.exports = __webpack_public_path__ + "static/media/TowerIcon2.2d2f204f.svg";